import { BaseTool } from '../BaseTool';

/**
 * Synchronize with Central — pushes local changes to the central model and
 * pulls the team's updates. Opens the Synchronize dialog (comment + options).
 */
export class SynchronizeWithCentralTool extends BaseTool {
    id = 'COLLAB_SYNC';
    name = 'Synchronize with Central';
    cursor = 'default';

    onActivate(): void {
        this.context?.appStore.openCollabDialog('synchronize');
        this.context?.appStore.setActiveTool('select');
    }

    onPointerDown(): void { }
    onPointerMove(): void { }
    onPointerUp(): void { }
}
